import "moment-timezone";
import React, { Component } from "react";
import 'react-block-ui/style.css';
import { Nav, NavItem } from 'react-bootstrap';
import { Route, Switch } from 'react-router';
import { Link } from "react-router-dom";
import LoadingIndicator from '../Components/LoadingIndicator/LoadingIndicator';
import CallRecordsListView from './CallRecordsListView';



class CallRecords extends Component {
  constructor(props) {
    super(props);

    const { view } = props.match.params
    this.state = { activeView: view, stats: {} }

  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.view !== prevProps.view) {
      this.setState({ view: this.props.view })
    }
  }

  fetchStats() {
    this.setState({ stats: {} });
  }

  handleSelect = (eventKey) => {
    this.setState({ activeView: eventKey }, () => {
    });
  }

  render() {
    const { blockUI } = this.state;

    return (
      <LoadingIndicator loadingInProgress={blockUI}>
          <div>
            <h1 className="first-title" style={{ marginBottom: '20px' }}>
              Call Records
            </h1>
            <div className='row'>
              <div className='col-md-12'>
                <Nav bsStyle="tabs" activeKey={this.state.activeView} onSelect={this.handleSelect.bind(this)}>
                <NavItem eventKey='open_voicemail' componentClass={Link} to={`/m1/call_records/list/open_voicemail`} href={`/m1/call_records/list/open_voicemail`}>Open Voicemail</NavItem>
                <NavItem eventKey='all_voicemail' componentClass={Link} to={`/m1/call_records/list/all_voicemail`} href={`/m1/call_records/list/all_voicemail`}>All Voicemail</NavItem>
                <NavItem eventKey='all' componentClass={Link} to={`/m1/call_records/list/all`} href={`/m1/call_records/list/all`}>All Calls</NavItem>
                <NavItem eventKey='outgoing' componentClass={Link} to={`/m1/call_records/list/outgoing`} href={`/m1/call_records/list/outgoing`}>Outgoing Calls</NavItem>
                <NavItem eventKey='long_outgoing' componentClass={Link} to={`/m1/call_records/list/long_outgoing`} href={`/m1/call_records/list/long_outgoing`}>Long Outgoing Calls</NavItem>
                <NavItem eventKey='incoming' componentClass={Link} to={`/m1/call_records/list/incoming`} href={`/m1/call_records/list/incoming`}>Incoming Calls</NavItem>
                <NavItem eventKey='zoom_all' componentClass={Link} to={`/m1/call_records/list/zoom_all`} href={`/m1/call_records/list/zoom_all`}>Zoom</NavItem>
                </Nav>
                <div className="tab-content">
                <Switch>
                  <Route path={'/m1/call_records/list/:view'} render={(props) => <CallRecordsListView view={this.state.activeView} {...props} />} />
                </Switch>
                </div>
              </div>
            </div>

          </div>
      </LoadingIndicator>

    );
  }
}
export default CallRecords;
